function splider() {
  initSplide('.js-splide-gallery-with-desc', {
      type   : 'loop',
      perPage: 2,
      perMove: 2,
      pagination: true,
      arrows: true,
      
      gap: 8,
      breakpoints: {
        767: {
            perPage: 1,
            perMove: 1,
            focus  : 'center',
          },
        }
  });
}

function initSplide(selector, options) {
    const sliders = document.querySelectorAll(selector);

    sliders.forEach(slider => {
        new Splide(slider, options).mount();
    });
}

document.addEventListener('DOMContentLoaded', splider);